import { cn } from '@/lib/utils';

const Hint = ({ children, onClick }: { children: React.ReactNode; onClick?: () => void }) => {
  return (
    <p
      className={cn('text-muted-foreground text-sm', onClick && 'cursor-pointer')}
      onClick={onClick}
    >
      {children}
    </p>
  );
};

export default Hint;
